import React, { useEffect } from 'react';
import { useStore } from 'react-redux';
import { routerHelperActions, selectRouterHelper } from '@wfp-common/store/routerHelperSlice';
import { useNavigate } from '@wfp-common/hooks/useNavigate';
import { Routes } from 'react-router-dom';
import { dispatch, useStoreSelector } from '@wfp-root-app/store/store';

import scheduleManagerTokenExpirationChecks from '../utils/sessionExpiration/scheduleManagerTokenExpirationChecks';
import getRoutes from '../Routes';

function scheduleTokenExpirationChecks() {
    if (document.visibilityState === 'visible') {
        dispatch(scheduleManagerTokenExpirationChecks());
    }
}

document.addEventListener('visibilitychange', scheduleTokenExpirationChecks);
scheduleTokenExpirationChecks();

const App = () => {
    const store = useStore();
    const routerHelper = useStoreSelector(selectRouterHelper);
    const navigate = useNavigate();

    useEffect(() => {
        if (!routerHelper.redirectUrl) return;

        const reg = /^\/\S*$/g.test(routerHelper.redirectUrl);
        navigate(reg ? routerHelper.redirectUrl : `/${routerHelper.redirectUrl}`, {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...(routerHelper.navigateState as any),
        });
        store.dispatch(routerHelperActions.clearRedirect());
    }, [routerHelper.redirectUrl]);

    return <Routes>{getRoutes()}</Routes>;
};

export default App;
